<template>
  <div>
    <h3 style="text-align: left;">Content Management</h3>
  </div>
</template>

<script>
//import ... from '@/components/...'
export default {
  name: "NewComponent",
  components: {},
  data() {
    return {
      status: "Ready"
    }
  },
  computed: {},
  created: function() {},
  mounted: function() {},
  updated: function() {},
  destroyed: function() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
